/**
 * The Fusion Eat console's reports, in one place.
 *
 * Read by MealsHome.vue (the buttons on the page) and MealsMenu.vue (the
 * app-bar dots menu), so the two can never list different things or give the
 * same report two colours.
 *
 * Each report has its own colour, and its own row of buttons repeats that
 * colour in tonal, which reads as a path (Maurizio, 2026-09-18: "like a path:
 * Production -> cook, delivery ... has the same color"). These belong to this
 * console, not to the module palette in config/moduleVisuals.js — Fusion Eat
 * as a whole stays deep-orange there.
 */
export const MEALS_REPORTS = [
  { key: "orders", title: "Orders", subtitle: "who ordered what", icon: "mdi-clipboard-list-outline", color: "blue-darken-1" },
  { key: "production", title: "Production", subtitle: "cook + pack", icon: "mdi-chef-hat", color: "deep-orange" },
  // Procurement is hidden for now, not deleted (Maurizio, 2026-09-18: "let's
  // comment out the shopping list button. keep the code will see in the
  // future"). Iqbal's verdict after linking the recipes: nearly everything a
  // meal set needs is bought for the restaurants anyway, so a shopping list of
  // routine ingredients tells him nothing he does not already buy — the one
  // exception being the beef for the rice dishes. It earns its place again
  // when the menu grows beyond what the kitchen already stocks (the Arabic
  // dishes he has in mind). ProcurementTab.vue, the endpoint and the
  // recipe-resolving logic are all untouched: put this line back and it
  // returns, in the menu and on the page.
  // { key: "procurement", title: "Procurement", subtitle: "shopping list", icon: "mdi-cart-outline", color: "teal-darken-1" },
  { key: "billing", title: "Billing", subtitle: "invoice for the period", icon: "mdi-receipt-text-outline", color: "purple-darken-1" },
  // Individual customers' prepaid plans: who pays what, collected or not, receipts (phase 2, 2026-10-15)
  { key: "plans", title: "Plans", subtitle: "individuals' payments", icon: "mdi-cash-check", color: "green-darken-2" },
  { key: "clients", title: "Clients", subtitle: "companies + staff", icon: "mdi-domain", color: "indigo" },
  { key: "menu", title: "Menu", subtitle: "meal sets", icon: "mdi-silverware-fork-knife", color: "brown" },
  // Settings for every client (the invoice e-mails' copy, and later others) —
  // in the dots menu only, never a button on the page (Maurizio, 2026-10-07).
  { key: "settings", title: "Settings", subtitle: "for all clients", icon: "mdi-cog-outline", color: "blue-grey" },
];

/**
 * The ones with a button on the page: the work of running a delivery week —
 * who ordered, what to cook, what to invoice, and the menu itself. Menu spent
 * a day in the dots menu and Iqbal could not find it (19 Sep 2026: "I am
 * unable to find the menu") — he sets the rice protein before each week
 * opens, so it is weekly work, not an occasional screen. Only Clients stays
 * menu-only: a client is set up once. Billing earns its
 * place because a weekly client is invoiced every week, not once a month
 * (Maurizio, 2026-09-18: "the same i'd say for invoicing especially in weekly
 * cases"). What is left in the menu alone is genuinely occasional: a client is
 * set up once, the meal-set catalogue changes now and then. The menu still
 * lists every report either way.
 */
export const DAILY_REPORT_KEYS = ["orders", "production", "billing", "menu"];
